<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module title="기본정보" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 산업보건의 활동 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 산업보건의 활동</h5>
      <div class="writeGridContainer">
        <div>
          <div>활동날짜</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <date-selector v-else v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>활동의사</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <ml-input v-else v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>총상담인원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <comma-input v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
<!--        <div>-->
<!--          <div>근골격상담인원</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>-->
<!--          <comma-input v-else v-model="form.inputA_6" :readonly="board.readonly" />-->
<!--        </div>-->
        <div class="writeGridLineItem">
          <div>건강상담내용</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_7 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_7" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>비고</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <ml-input v-else v-model="form.inputA_8" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        fileList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
